import { render } from "./TerminalsComponent.vue?vue&type=template&id=712e2f93&scoped=true"
import script from "./TerminalsComponent.vue?vue&type=script&lang=js"
export * from "./TerminalsComponent.vue?vue&type=script&lang=js"

import "./TerminalsComponent.vue?vue&type=style&index=0&id=712e2f93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712e2f93"]])

export default __exports__